var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoundOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 5.899L7.899 9.397C7.732 9.51 7.535 9.572 7.333 9.572H3V14.429H7.333C7.535 14.429 7.732 14.491 7.899 14.604L13 18.102V5.899ZM15 4.001V20.001C15 20.372 14.794 20.712 14.466 20.885C14.32 20.962 14.16 21.001 14 21.001C13.802 21.001 13.604 20.942 13.435 20.826L7.023 16.429H2C1.448 16.429 1 15.982 1 15.429V8.572C1 8.019 1.448 7.572 2 7.572H7.023L13.435 3.175C13.74 2.965 14.137 2.942 14.466 3.116C14.794 3.289 15 3.629 15 4.001ZM19.138 5.23C18.712 4.878 18.082 4.937 17.73 5.363C17.377 5.788 17.437 6.419 17.862 6.771C19.563 8.18 20.5 10.037 20.5 12.001C20.5 13.964 19.563 15.821 17.862 17.23C17.437 17.583 17.377 18.213 17.73 18.638C17.928 18.878 18.213 19.001 18.5 19.001C18.725 19.001 18.951 18.925 19.138 18.771C21.306 16.975 22.5 14.57 22.5 12.001C22.5 9.431 21.306 7.026 19.138 5.23ZM17.779 15.628C17.582 15.873 17.292 16.001 17 16.001C16.779 16.001 16.558 15.928 16.373 15.78C15.943 15.433 15.875 14.804 16.221 14.374C17.256 13.087 17.256 10.914 16.221 9.628C15.875 9.197 15.943 8.568 16.373 8.221C16.803 7.877 17.433 7.944 17.779 8.374C19.416 10.408 19.416 13.593 17.779 15.628Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOn);
export default __webpack_public_path__ + "static/media/sound-on.c9b408280c9aa2006c8977c95189e3c9.svg";
export { ForwardRef as ReactComponent };